import storeHelper from '@/helpers/store';

export default {
	...storeHelper.generateStore('Parts'),
};
